import { Navigate } from "react-router-dom";
import { DialogsProvider } from "@/context/DialogsContext";
import SEOPageLayout from "@/components/seo/SEOPageLayout";
import QuoteFormDialog from "@/components/forms/QuoteFormDialog";
import { useSEO } from "@/hooks/useSEO";
import { getMainServiceBySlug, getPhase1MainServices } from "@/data/seo/mainServices";
import { getPhase1Cities } from "@/data/seo/cities";
import { WHY_US_ITEMS, FAQ_ITEMS } from "@/constants/business";
import { localBusinessSchema, serviceSchema, faqSchema, breadcrumbSchema } from "@/lib/schema";

const PROFILE_BY_SLUG = {
  "transport-entreprise": "entreprise",
  "transport-institution": "institution",
};

export default function ServicePage({ serviceSlug }) {
  const service = getMainServiceBySlug(serviceSlug);

  const path = `/${serviceSlug}`;
  const description = service?.metaDescription || "";
  const faqSubset = FAQ_ITEMS.slice(0, 6);
  const otherServices = service ? getPhase1MainServices().filter((s) => s.slug !== service.slug) : [];
  const phase1Cities = getPhase1Cities().slice(0, 10);

  const breadcrumbItems = service ? [{ label: "Accueil", href: "/" }, { label: service.label }] : [];

  useSEO({
    title: service?.metaTitle || "",
    description,
    path,
    isIndexable: !!service?.isPhase1,
    jsonLd: service
      ? [
          localBusinessSchema(),
          serviceSchema({ name: service.label, description, url: path }),
          faqSchema(faqSubset),
          breadcrumbSchema(breadcrumbItems),
        ]
      : null,
  });

  if (!service) return <Navigate to="/404" replace />;

  const relatedGroups = [
    {
      title: "Disponible dans nos principales zones",
      items: phase1Cities.map((c) => ({ label: c.name, href: `/transport-${c.slug}` })),
    },
    {
      title: "Autres services",
      items: otherServices.map((s) => ({ label: s.label, href: `/${s.slug}` })),
    },
  ];

  return (
    <DialogsProvider>
      <SEOPageLayout
        testIdPrefix="service-page"
        breadcrumbItems={breadcrumbItems}
        eyebrow="Nos services"
        h1={service.h1}
        intro={service.intro}
        serviceLinks={otherServices.map((s) => ({ label: s.label, href: `/${s.slug}` }))}
        trustItems={WHY_US_ITEMS.slice(0, 6).map((i) => i.text)}
        relatedGroups={relatedGroups}
        faqItems={faqSubset}
        ctaProfile={PROFILE_BY_SLUG[service.slug] || "particulier"}
      />
      <QuoteFormDialog />
    </DialogsProvider>
  );
}
